export default __webpack_public_path__ + "static/media/US.17725c82.svg";